
import { FormAction, FormState } from './types';
import { formConfig } from '../../config/formConfig';
import { useToast } from '../../hooks/use-toast';
import { submitFormData } from './utils/formSubmission';

export const useFormActions = (
  state: FormState, 
  dispatch: React.Dispatch<FormAction>,
  isAdmin: boolean = false
) => {
  const { toast } = useToast();
  const totalPages = formConfig.length;
  
  const nextPage = () => {
    if (state.currentPage < totalPages) {
      dispatch({ type: 'SET_PAGE', payload: state.currentPage + 1 });
      window.scrollTo(0, 0);
    }
  };

  const prevPage = () => {
    if (state.currentPage > 1) {
      dispatch({ type: 'SET_PAGE', payload: state.currentPage - 1 });
      window.scrollTo(0, 0);
    }
  };

  const setField = (name: string, value: string | string[] | boolean | File[]) => {
    dispatch({ type: 'SET_FIELD', payload: { name, value } });
  };
  
  // Add alias for setField to maintain backwards compatibility
  const updateField = setField;

  const setError = (name: string, error: string) => {
    dispatch({ type: 'SET_ERROR', payload: { name, error } });
  };

  const clearError = (name: string) => {
    dispatch({ type: 'CLEAR_ERROR', payload: name });
  };

  const submitForm = async () => {
    await submitFormData(state, dispatch, toast, isAdmin);
  };

  return {
    nextPage,
    prevPage,
    setField,
    updateField,
    setError,
    clearError,
    submitForm
  };
};
